import {
  ADD_BRANCH_OFFICER,
  GET_BRANCH_OFFICER,
  EDIT_BRANCH_OFFICER,
  DELETE_BRANCH_OFFICER,
  BLOCK_BRANCH_OFFICER,
} from "../constants/action-types";

const initilState = {
  state: "",
};

const branchOfficerReducer = (state = initilState, action) => {
  switch (action.type) {
    case ADD_BRANCH_OFFICER:
      return {
        ...state,
        ...state.data.push(action?.payload),
      };
    case GET_BRANCH_OFFICER:
      return {
        ...state,
        data: action.payload,
      };
    case EDIT_BRANCH_OFFICER:
      const index = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(index, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    case DELETE_BRANCH_OFFICER:
      const deleteIndex = state.data.filter(
        (ele) => ele.id !== action?.payload.id
      );
      return {
        ...state,
        data: deleteIndex,
      };
    case BLOCK_BRANCH_OFFICER:
      const blockIndex = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(blockIndex, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    default:
      return state;
  }
};

export default branchOfficerReducer;
